import { Routes, Route, Navigate } from 'react-router-dom';
import appInfo from '../../configs/app-info';
import routes from '../../configs/app-routes';
import { SideNavInnerToolbar as SideNavBarLayout } from '..';
import { Footer } from '../../components';
import AppRoutes from '../../routes';

export default function Content() {
  return (
    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {routes.map(({ path, element }) => {
          // console.log(path, element, 'CONTENT');
          return (
            <Route
              key={path}
              path={path}
              element={element}
            />
          );
        })}
        <Route
          path='*'
          element={<Navigate to='/' />}
        />
      </Routes>
      <Footer>
        Copyright © {new Date().getFullYear()} {appInfo.title}
        <br />
      </Footer>
    </SideNavBarLayout>
  );
}

